export const SET_TEMPLATE = "TEMPLATE_SET_TEMPLATE";
export const SET_ERROR = "TEMPLATE_SET_ERROR";
export const SET_FETCHING = "TEMPLATE_SET_FETCHING";
export const SET_SENDING = "TEMPLATE_SET_SENDING";
